// 修改runningtime
const getRunningEnv = () => {
  const config = require('../../../yxlConfig.json')
  return {
    isDev: config.env !== '',
    env: config.env
  }
}

function codeHandler(res, platform) {
  return new Promise(resolve => {
    const { code, data } = res.data
    if (code * 1 === 1) {
      resolve(res.data)
    } else if (code == 1006) {
      // 如果是1006且是app环境，提示登录跳转app登录
      // 1006没有给data，不用redirect了
      // redirectHandler(data, platform)
      resolve(res.data)
    } else if (code == 302) {
      // 如果是302且是app，跳转app登录
      redirectHandler(data, platform)
      resolve(res.data)
    } else if (code == 200) {
      resolve(res.data)
    } else {
      resolve(res.data)
    }
  })
}

function redirectHandler(data, platform) {
  if (
    platform.isYixinliApp &&
    data.indexOf('.xinli001.com/account/login') >= 0
  ) {
    location.href = 'yixinli://open_user_login'
  } else if (
    platform.isMuseApp &&
    data.indexOf('.xinli001.com/account/login') >= 0
  ) {
    console.log('client redirectHandler login', data)
    location.href = 'muse://open_user_login'
  } else {
    console.log('前端302-H5：' + data)
    if (data) {
      // 当data链接跳转的是详情页时，原因是未参与或者书籍音频数据不全等问题
      location.replace(data)
    }
  }
}

export default {
  install(Vue, options) {
    // require('lib/lib/flexible')
    require('../style/iconfont/iconfont.css')
    require('../style/numfont/DharmaTypeBebasKai.css')
    require('../style/numfont/OPPOSans.css')
    require('../bus/index.js')
    require('../framework/wxapp.js')
    require('../../static/sprites/icon.scss')
    // require('@yxl/components/es/v2.7/pic/style.css')
    let { env } = getRunningEnv()
    const axios = require('axios')
    const VueAwesomeSwiper = require('vue-awesome-swiper/dist/ssr')
    const bridgePlugin = require('utils/bridgePlugin')
    const { getPlatform } = require('lib/tools/getPlatform')
    // const globalMixin = require('mixins/global')
    // const meditationGlobalMixin = require('mixins/meditation/globalMixin')
    const statPlugin = require('lib/mixins/statPlugin').default
    const directivesPlugin = require('utils/directivesPlugin').default
    const isSupportWebp = require('app/web/utils/isSupportWebp.js')
    const { imgZip } = require('app/web/filters/ossImg.js')
    // const _const = require('../const/index').default
    // const { loadScript } = require('lib/tools/loadScript')
    const {
      GetQueryString,
      isCanHideNavigationBar,
      wxConfigOrigin
    } = require('lib/tools/utils')
    const { trackPlugin } = require('@yxl/libs')
    const allToApp = require('@yxl/open-app').default

    try {
      window.addAxiosCatchErrorInterceptors(axios)
    } catch (e) {
      console.log(e)
    }
    // const vuePhotoPreviewPath = `https://static${
    //   env ? `-${env}` : ''
    // }.xinli001.com/node-website/public/static/vue-photo-preview/dist`
    // loadScript(`${vuePhotoPreviewPath}/vue-photo-preview.js`).then(() => {
    //   const options = {
    //     fullscreenEl: false //关闭全屏按钮
    //   }
    //   /* eslint-disable */
    //   Vue.use(vuePhotoPreview, options)
    // })
    // require('../../static/vue-photo-preview/dist/skin.css')
    if (process.env.NODE_ENV !== 'production') {
      const VConsole = require('vconsole')
      new VConsole()
    }
    // set wechat title
    Vue.use(require('vue-wechat-title'))
    Vue.use(VueAwesomeSwiper)
    Vue.use(trackPlugin, {
      router: options.router
    })
    Vue.use(allToApp)
    const platform = getPlatform()
    Vue.prototype.$platform = window.$platform = getPlatform()
    // Vue.prototype.$runningEnv = getRunningEnv()
    // Vue.prototype.$const = _const
    Vue.prototype.$origin = window.location.origin
    Vue.prototype.$mediWarnOrigin = wxConfigOrigin(
      require('../../../yxlConfig.json'),
      'MEDI_ORIGIN',
      'm_warn'
    )
    Vue.prototype.$mRiskOrigin = wxConfigOrigin(
      require('../../../yxlConfig.json'),
      'XY_ORIGIN',
      'm_risk',
      false,
      'http:'
    )

    Vue.prototype.$mZXSafeOrigin = window.$getMP
      ? window.location.origin // 小程序用m
      : wxConfigOrigin(
          require('../../../yxlConfig.json'),
          'ZX_ORIGIN',
          'm_safe',
          false,
          'http:'
        )
    Vue.prototype.$pathName = window.location.pathname

    Vue.prototype.$bus = require('../bus/index.js').default() // 创建bus实例

    Vue.use(require('lib/component/vue/entry.js').default)
    const qs = require('qs')
    Vue.component('v-touch', require('component/common/v-touch-fake').default)

    // isCanHideNavigationBar返回true，说明没有原生导航栏
    Vue.prototype.canHideNavigationBar = isCanHideNavigationBar(platform)

    axios.formatEnvInterceptor = axios.interceptors.request.use(async res => {
      let { url } = res
      if (env) {
        if (res.url.indexOf('m.xinli001') > -1) {
          res.url = url.replace('m.xinli001', `m-${env}.xinli001`)
        }
        // 微服务接口
        if (res.url.indexOf('mse.xinli001') > -1) {
          res.url = url.replace('mse.xinli001', `mse-${env}.xinli001`)
        }
        //冥想星球的接口
        if (res.url.indexOf('kc.xinli001') > -1) {
          res.url = url.replace('kc.xinli001', `kc-${env}.xinli001`)
        }
        // 主题场景的接口
        if (res.url.indexOf('www.xinli001') > -1) {
          res.url = url.replace('www.xinli001', `www-${env}.xinli001`)
        }
        // 平台的接口
        if (res.url.indexOf('yiapi.xinli001.com') > -1) {
          res.url = url.replace(
            'yiapi.xinli001.com',
            `yiapi-${env}.xinli001.com`
          )
        }
        // 问答接口
        if (res.url.indexOf('qaapi.xinli001') > -1) {
          res.url = url.replace('qaapi.xinli001', `qaapi-${env}.xinli001`)
        }

        // 测评接口
        if (res.url.indexOf('lingxi.xinli001.com') > -1) {
          res.url = url.replace('lingxi.xinli001', `lingxi-${env}.xinli001`)
        }
        if (res.url.indexOf('yiapp.xinli001.com') > -1) {
          res.url = url.replace('yiapp.xinli001', `yiapp-${env}.xinli001`)
        }
        if (res.url.indexOf('mse.xinli001.com') > -1) {
          res.url = url.replace('mse.xinli001', `mse-${env}.xinli001`)
        }
        if (res.url.indexOf('api-college.xinli001.com') > -1) {
          res.url = url.replace(
            'api-college.xinli001',
            `api-college-${env}.xinli001`
          )
        }
      }
      const bus = new Vue().$bus
      //冥想的接口(有lingxikc的接口)需要默认带上几个参数
      if (url.includes('lingxikc') && !url.includes('axios=lesson')) {
        let channelId = 1741
        if (bus.channelId) {
          channelId = bus.channelId * 1 <= 0 ? 1741 : bus.channelId
        }
        // eslint-disable-next-line
        async function getTokenAndUserId() {
          return await Vue.prototype.$bridge.getTokenAndUserId()
        }

        let token = null,
          userId = null

        // eslint-disable-next-line
        function afterGetTU() {
          let sendToken = platform.isMuseApp
            ? token || (res.params && res.params.token)
            : token ||
              (res.params && res.params.token) ||
              GetQueryString('token')
          let sendUserId = platform.isMuseApp
            ? userId || (res.params && res.params.userId)
            : userId ||
              (res.params && res.params.userId) ||
              GetQueryString('userId')
          const baseParams = {
            channelId,
            sourceName: bus.sourceName,
            disCode: bus.disCode,
            token: sendToken,
            userId: sendUserId,
            _platform: GetQueryString('_platform'),
            _version: GetQueryString('_version'),
            _appSource: GetQueryString('_appSource'),
            nodeSource: getPlatform().isMuseApp ? 'museApp' : 'muse',
            locationHash:
              (res.params && res.params.toLocationHash) ||
              window.location.pathname + window.location.search // 后端重定向
          }

          switch (res.method) {
            case 'get':
              res.params = Object.assign({}, res.params, baseParams)
              break
            case 'post':
              res.data = qs.stringify(Object.assign({}, res.data, baseParams))
              break
          }
        }

        if (platform.isMuseApp) {
          await getTokenAndUserId().then(obj => {
            token = obj && obj.token ? obj.token : null
            userId = obj && obj.userId ? obj.userId : null
            afterGetTU()
          })
        } else {
          afterGetTU()
        }
      }
      if (
        (platform.isYixinliApp || platform.isMuseApp || platform.isZiXunApp) &&
        !(url.includes('lingxikc') && !url.includes('axios=lesson'))
      ) {
        //灵犀接口不用这个，pageMixin.js已经有了
        return Vue.prototype.$bridge.getToken().then(obj => {
          console.log(obj)
          if (typeof obj === 'object' && !!obj.token) {
            const { token } = obj
            if (res.url.indexOf('?') === -1) {
              res.url += '?token=' + token
            } else {
              res.url += '&token=' + token
            }
          }
          return Promise.resolve(res)
        })
      } else if (Vue.prototype.$getMP) {
        let miniProgramUid = location.search
          .substr(1)
          .split('&')
          .find(item => item.includes('miniProgramUid='))
        if (miniProgramUid) {
          let uid = miniProgramUid.split('=')[1]
          if (res.url.indexOf('?') === -1) {
            res.url += '?uid=' + uid
          } else {
            res.url += '&uid=' + uid
          }
        }
        return res
      } else if (platform.isZiXunShiApp) {
        const token = GetQueryString('token')
        if (res.url.indexOf('?') === -1) {
          res.url += '?token=' + token
        } else {
          res.url += '&token=' + token
        }
        return res
      } else {
        return res
      }
    })
    Vue.use(bridgePlugin.default, options)
    // Vue.mixin(globalMixin.default)
    // Vue.mixin(meditationGlobalMixin.default)
    //冥想星球全局过滤器
    // const filters = require('../filters/meditation')
    // Vue.prototype.$filter = filters
    // Object.keys(filters).forEach(key => {
    //   Vue.filter(key, filters[key])
    // })
    //
    Vue.prototype.$isSupportWebp = isSupportWebp()
    Vue.filter('imgZip', (url, w, h) => {
      // 返回处理后的值
      return imgZip(url, w, h, Vue.prototype.$isSupportWebp)
    })

    Vue.prototype.sleep = (t = 20) =>
      new Promise(resolve => setTimeout(resolve, t))

    Vue.use(statPlugin, options)
    Vue.use(directivesPlugin) //注册全局指令
    // main.js
    // const VueSlider = require('vue-slider-component')
    // require('vue-slider-component/theme/default.css')
    // Vue.component('VueSlider', VueSlider)

    // const meditationPayMixin = require('mixins/meditation/meditationPayMixin')
    // Vue.mixin(meditationPayMixin.default)
    // if (!Vue.prototype.$getMP) {
    //   // 小程序不要带上cookie
    //   axios.defaults.withCredentials = true
    // }
    axios.defaults.withCredentials = true
    // 针对40001未登录错误做统一处理
    axios.flatDataInterceptor = axios.interceptors.response.use(
      res => {
        // 冥想星球接口-拦截接口
        if (res.config.url.indexOf('lingxikc') >= 0) {
          if (res.status && res.status !== 200) {
            Vue.prototype.$toast('服务器出错')
            return res
          } else {
            const { getPlatform } = require('lib/tools/getPlatform')
            return codeHandler(res, getPlatform())
          }
        }

        /**
         * 后端未登录错误码有可能是40001 40002,但是40002部分是 “用户行为拦截”，比如阻止多次评论等
         * post(url, postdata, {
        disabledUnLoginInterceptors: true
      })
         * get(APIs.list, {
        params,
        disabledUnLoginInterceptors: true
      })
         */
        if (res.config.disabledUnLoginInterceptors === true) {
          return res.data
        }
        if (+res.data.code === 40001 || +res.data.code === 40002) {
          let UA = navigator.userAgent
          const { isYixinliApp, isZiXunApp } = platform
          if (isYixinliApp || isZiXunApp) {
            window.location.href = 'yixinli://open_user_login'
          } else if (UA.indexOf('muse') >= 0) {
            console.log('client interceptors login', res)
            window.location.href = 'muse://open_user_login'
          } else {
            let { env } = getRunningEnv()
            let url = `https://m.xinli001.com/account/login?next=${encodeURIComponent(
              window.location.href
            )}`
            if (env) {
              url = url.replace('m.xinli001', `m-${env}.xinli001`)
            }
            if (window.$getMP) {
              window.$uniAppNavto.push({
                path: '../webView/webView?src=' + encodeURIComponent(url)
              })
            } else {
              window.location.href = url
            }
          }
          // localStorage.removeItem("token");
        }
        // 如果是kc接口且是302就重定向
        if (+res.data.code === 302 && res.config.url.indexOf('//kc') >= 0) {
          if (res.data.data) {
            window.location.href = res.data.data
          }
        }
        return res.data
      },
      err => {
        return Promise.reject(err)
      }
    )
  }
}
